import script from "./Daiwari.vue?vue&type=script&setup=true&lang=ts"
export * from "./Daiwari.vue?vue&type=script&setup=true&lang=ts"

import "./Daiwari.vue?vue&type=style&index=0&id=3c9843fa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c9843fa"]])

export default __exports__